import { FakeAvatarsGroup, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { TalkToSalesProps as Props } from './types';

export const TalkToSales = memo(({ className }: Props) => {
  return (
    <Box className={classnames('TalkToSales', className)} sx={SX.root}>
      <Box sx={SX.row}>
        <FakeAvatarsGroup count={4} />
        <Stack>
          <Typography variant="body4" fontWeight={700} color="grey.900">
            Talk to Sales
          </Typography>
          <Typography variant="body5" color="grey.600">
            Customer Support
          </Typography>
        </Stack>
      </Box>
      {/* TODO(CU-86e003n9m): wire to sales booking flow once destination is decided */}
      <Button
        variant="contained"
        color="primary"
        size="small"
        fullWidth
        disabled
        startIcon={<Icon name="calendar-today-outline" size={16} />}
      >
        Book a Call
      </Button>
    </Box>
  );
});

TalkToSales.displayName = 'TalkToSales';
